




























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetDaohang,
  AddDaohang,
  EditDaohang,
  DelDaohang,
  MoveDaohang,
  EditDetail,
} from "@/request/schema";
import { GetSechemaList } from "@/request/mark";
@Component({})
export default class Name extends Vue {
  private currentNode: any = {};
  private expandedNode: any = [];
  private data: any = [];
  private addJiegouData: any = {};
  private modifyData: any = {};
  private ifModify: any = false;
  private clickData: any = {}; // 点击的数据
  private defaultProps: any = {
    label: "名称",
  };
  private ifShowfanxiang: any = false;
  private relations: any = [];
  private searchGuanxiOptions(e: any) {
    const params: any = {
      params: {
        search: e,
        type: "关系类型",
      },
    };
    GetSechemaList(this, params).then((data: any) => {
      this.relations = data;
      // 如果当前结果不在选项里需要添加进去
      if (this.modifyData.id) {
        const index: any = this.relations.findIndex((val: any) => {
          return val.id == this.modifyData.id;
        });
        if (index == -1) {
          this.relations.unshift(this.modifyData);
        }
      }
    });
  }
  private fanxiangSure() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      _id: this.currentNode._id,
      define_desc: this.modifyData.id,
      field: "reverse_relation_id",
    };
    EditDetail(this, params, loading).then((res: any) => {
      loading.close();
      this.$message.success("编辑成功！");
      this.ifShowfanxiang = false;
      this.getNav();
    });
  }
  private add(data: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      type: "关系类型",
      name: data.name,
      类别: data.category,
    };
    AddDaohang(this, params, loading).then((res: any) => {
      this.$message.success("添加成功！");
      loading.close();
      this.getNav();
    });
  }
  private remove(node: any, data: any) {
    const parent = node.parent;
    const children = parent.data.children || parent.data;
    const index = children.findIndex((d: any) => d.id === data.id);
    children.splice(index, 1);
  }
  private handleCommand(e: any) {
    this.clickData = e.data;
    if (e.command == "重命名") {
      this.modifyData = {
        name: this.currentNode["名称"],
      };
      this.ifModify = true;
    } else if (e.command == "编辑反向关系") {
      this.searchGuanxiOptions("");
      this.modifyData = {
        id: this.clickData.reverse_relation_id,
        relation: this.clickData["反向关系"],
      };
      this.$forceUpdate();
      this.ifShowfanxiang = true;
    } else if (e.command == "删除") {
      this.$confirm("您确定要删除该关系类型么？", "删除", {
        customClass: "commonConfirm",
      })
        .then(() => {
          const params: any = {
            data: {
              _id: this.clickData._id,
            },
          };
          const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
          });
          DelDaohang(this, params, loading).then((res: any) => {
            loading.close();
            this.$message.success("删除成功！");
            this.getNav().then((d: any) => {
              this.currentNode = this.data[0].children[0];
              this.init();
            });
          });
        })
        .catch(() => {
          console.log("取消");
        });
    }
  }
  private modify() {
    if (!this.modifyData.name) {
      this.$message.warning("请输入关系类型名称！");
      return;
    }
    const params: any = {
      _id: this.clickData._id,
      name: this.modifyData.name,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditDaohang(this, params, loading).then((res: any) => {
      loading.close();
      this.$message.success("重命名成功");
      this.ifModify = false;
      this.getNav().then((d: any) => {
        this.currentNode = {
          _id: this.currentNode["_id"],
          名称: this.modifyData.name,
        };
        this.$emit("updateCurrentTree", this.currentNode);
        this.init();
      });
    });
  }
  // 拖拽成功完成时触发的事件
  private handleDrop(draggingNode: any, dropNode: any, dropType: any, ev: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      data: dropNode.parent.data.children,
    };
    MoveDaohang(this, params, loading).then((res: any) => {
      loading.close();
      this.$message.success("移动成功！");
      this.getNav().then((d: any) => {
        this.currentNode = draggingNode.data;
        this.init();
      });
    });
  }
  private handleNodeClick(data: any, node: any) {
    if (data._id) {
      this.currentNode = data;
      this.init();
    }
  }
  private init() {
    if (this.$refs.guanxiTree) {
      (this.$refs.guanxiTree as any).setCurrentKey(this.currentNode);
      this.expandedNode = [this.currentNode._id];
      this.$emit("updateCurrentTree", this.currentNode);
    }
  }
  private allowDrop(draggingNode: any, dropNode: any, type: any) {
    if (
      !dropNode.data["_id"] ||
      !draggingNode.data._id ||
      type == "inner" ||
      draggingNode.data["类别"] != dropNode.data["类别"]
    ) {
      return false;
    } else {
      return true;
    }
  }
  private getNav() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          type: "关系类型",
        },
      };
      GetDaohang(this, params, loading).then((res: any) => {
        loading.close();
        res.forEach((ele: any) => {
          ele["名称"] = ele["类别"];
        });
        this.data = res;
        // 如果当前已经选中，更新选中数据
        if (this.currentNode && this.currentNode._id) {
          res.forEach((element: any) => {
            element.children.forEach((ele: any) => {
              if (ele._id == this.currentNode._id) {
                this.currentNode = ele;
                this.init();
              }
            });
          });
        }
        resolve(res);
      });
    });
  }
  private refresh(d: any) {
    this.currentNode = d;
    this.init();
  }
  private updateTree() {
    this.getNav();
  }
  private mounted() {
    if (this.$route.query.data) {
      const d = JSON.parse(this.$route.query.data as any);
      if (d["类型"] == "关系类型") {
        this.getNav().then((data: any) => {
          this.currentNode = d;
          this.init();
        });
      } else {
        this.getNav().then((d: any) => {
          this.currentNode = this.data[0]["children"][0];
          this.init();
        });
      }
    } else {
      this.getNav().then((d: any) => {
        this.currentNode = this.data[0]["children"][0];
        this.init();
      });
    }
  }
}
